
var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "managedoutgoingcontactrequests",
	_who: null,
	_requests: null,
	_group: null,

	init: init,
	uninit: uninit,
	listeners: listeners,
	triggers: triggers,

	refresh: refresh,
	recalculate: recalculate,
	reset: reset,
	track_requests: track_requests
});

/**
 * Initializes the model with empty variables until 'managedaccount' updates.
 * @return {[type]} [description]
 */
function init() {
	this._group = null;
	this._who = null;
	this._who_tracker = this.dispatcher.createTracker(); //Create tracker object.
	this._requests = [];
	this._people = {};
	this.push([]);
	this.refresh();
}

function uninit() {
	this._group = null;
	this._who = null;
	this._who_tracker.off(); //Turn off tracker
	this._requests = null;
}

/**
 * Sets listeners for: a change in managed user, re/connect, an update of
 * 'people'.
 * @return {Object} Listeners
 */
function listeners() {
	return {
		"connectivity:online": refresh,
		"people:updated": handle_people_update,
	};
}

function triggers() {
	return {
		"view": view,
		"reset": reset,
	};
}

function view(data) {
	var who = data.who;
	const group = data.group;

	if(this._who === who) return;
	this._who = who;
	this._group = group;

	this.refresh();
	this.track_requests();
}

function track_requests() {
	var managee = this._who;
	var tracker = this._who_tracker;
	var group = this._group;
	tracker.off();

	if(group) {
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/contacts/requests/out/new", refresh.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/contacts/requests/out/accepted", refresh.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/contacts/requests/out/denied", refresh.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + managee + "/contacts/requests/out/cancelled", refresh.bind(this));
	} else {
		tracker.on("mqtt:u/" + managee + "/contacts/requests/out/new", refresh.bind(this));
		tracker.on("mqtt:u/" + managee + "/contacts/requests/out/accepted", refresh.bind(this));
		tracker.on("mqtt:u/" + managee + "/contacts/requests/out/denied", refresh.bind(this));
		tracker.on("mqtt:u/" + managee + "/contacts/requests/out/cancelled", refresh.bind(this));
	}
}

function handle_people_update(people) {
	this._people = people;
	this.recalculate();
}

function recalculate() {
	var people = this._people;
	var requests = this._requests;

	var merged = merge_with_people(people, requests);

	this.push(merged);
}

function merge_with_people(people, requests) {
	return requests.map(function (request) {
		return xtend(request, {
			to: people[request.to]
		});
	});
}

/**
 * Refreshes the list of outgoing requests when cued to do so by:
 * new/cancel/accept/deny on invites OR a change in the Person
 * being managed ('managee')
 * @return {[type]} [description]
 */
function refresh() {
	var managee = this._who;
	if (!managee) return;
	const group = this._group;

	return this.api.manage.contacts.requests
		.outgoing(managee, group)
		.then(process_requests.bind(this))
		.catch(console.error.bind(console));
}

/**
 * Populates '_requests' and emits a message to add them to 'people'
 * @param  {[type]} requests [description]
 * @return {[type]}          [description]
 */
function process_requests(requests) {
	if (!requests.length) {
		this.push([]);
		this._requests = [];
		return;
	}

	var ids = get_all_ids(requests);
	this._requests = requests;
	this.emit("people:trigger:add", {
		lean: true,
		who: ids
	});

	this.recalculate();
}

/**
 * Strips the 'to' _id from 'requests' array, and returns the array of _id's.
 * @param  {[type]} requests [description]
 * @return {[type]}          [description]
 */
function get_all_ids(requests) {
	return Object.keys(requests.reduce(function (result, request) {
		result[request.to] = true;
		return result;
	}, {}));
}

/**
 * Resets the trackers (turns them off), clears the model's data, and
 * sets the managee to 'null' ie. returns model to init() state.
 */
function reset() {
	this.emit("usermetrics:trigger:track", "close managed user's outgoing contact requests", {
		who: this._who,
	});
	this._who_tracker.off();
	this._who = null;
	this._group = null;
	this._requests = [];
	this.push([]);
}
